module.exports = __webpack_public_path__ + "static/media/man_gaoyudong.9ec86c0b.png";